exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-642b8b52]{margin:0 0 10px}h2[data-v-642b8b52]{text-decoration:underline;margin-bottom:5px}iframe[data-v-642b8b52]{height:360px;width:100%;border:0}.media-item[data-v-642b8b52]{margin-bottom:50px}@media (min-width:1200px){.media-item[data-v-642b8b52]{width:500px;margin:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-642b8b52","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MediaItem.vue
// module id = 228
// module chunks = 0